var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.25C0 1.73 1.23 0.5 2.75 0.5H8C9.105 0.5 10 1.395 10 2.5C10 3.605 9.105 4.5 8 4.5H3.75C3.06 4.5 2.5 3.94 2.5 3.25C2.5 2.56 3.06 2 3.75 2H7.5V3H3.705C3.43 3 3.43 3.5 3.705 3.5H8C8.55 3.5 9 3.05 9 2.5C9 1.95 8.55 1.5 8 1.5H2.75C1.785 1.5 1 2.285 1 3.25C1 4.215 1.785 5 2.75 5H7.5V6H2.75C1.23 6 0 4.77 0 3.25Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.08a56be746d8e2efcd1081b9b25c97a3.svg";
export { ForwardRef as ReactComponent };